import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { PersistenceService } from '../services/persistence.service';
import { AuthenticationService, AuthenticatedUser } from '../services/authentication.service';
import { ControllerService } from '../services/controller/controller.service';
import { firstValueFrom, filter, first } from 'rxjs';

export const worklistSubmissionAssignmentResolver: ResolveFn<string> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const persistenceService = inject(PersistenceService);
  const authenticationService = inject(AuthenticationService);
  const controllerService = inject(ControllerService);

  return firstValueFrom(
    authenticationService.currentUser$.pipe(
      filter((user): user is AuthenticatedUser => !!user),
      first()
    )
  ).then(async (currentUser) => {
    const courseId = route.params['courseId'];
    const assignmentId = route.params['assignmentId'];

    if (!courseId || !assignmentId) {
      return '';
    }

    // Show loading indicator
    const loading = await controllerService.loading();
    await loading.present();

    try {
      const response = await persistenceService.getAssignment({
        userId: currentUser.userId,
        courseId: courseId,
        assignmentId: assignmentId,
      });
      await loading.dismiss();
      return response.assignment?.name || '';
    } catch (error) {
      console.warn('Failed to load assignment name for title:', error);
      await loading.dismiss();
      return '';
    }
  });
};

